import MyAlgoConnect from "@randlabs/myalgo-connect";
import axios, * as others from "axios";
import "../components/nftcard/nftcard.css";
import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Checkbox from "@mui/material/Checkbox";
import FavoriteBorder from "@mui/icons-material/FavoriteBorder";
import Favorite from "@mui/icons-material/Favorite";
import TopBar from "../components/header/navbar/TopBar";
import Footer from "../components/footer/Footer";
import { db } from "./firebase";
import { addDoc, Timestamp, collection, getDocs, setDoc, doc, query, where } from "firebase/firestore";
import { toast } from "react-toastify";

const algosdk = require("algosdk");
const myAlgoWallet = new MyAlgoConnect();
const label = { inputProps: { "aria-label": "Checkbox demo" } };

const MintPage = (props) => {

  const [WalletAddress, setWalletAddress] = useState([]);
  const [Nfts, setNfts] = useState([]);
  const [StakedNfts, setStakedNfts] = useState([]);
  const [params, setParam] = useState("");
  const [show, setShow] = useState(false);
  const [myassetID, setmyAssetID] = useState(0);
  const [loadingState, setLoadingState] = useState(false);
  const [popupimage, setPopImage] = useState();
  const [firebaseStake, setfirebaseStake] = useState([]);
  const [FungTokenAccount, setFta] = useState([]);
  const [dateobj, setdateobj] = useState({});
  const [AllParams, setAllParams] = useState({});
  const [AllParamsManager, setAllParamsManager] = useState({});
  const [NFTGlobalAccount, setNFtGA] = useState([])
  const [firebaseData, setfirebaseData] = useState([])

  const hamza = "NKQBANAABRQENBLI7MI3YMMTJMDNHWJX6ZVFS3UYPTHXFQ24L5EUBBY52Y" //hamza

  const handleClose = () => setShow(false);
  const handleShow = (e, allparams, manager) => {
    setPopImage(allparams.url);
    setAllParams(allparams)
    setAllParamsManager(manager)
    setShow(true)
    const buttonID = e.target.id;
    const num1 = Number(buttonID)
    setmyAssetID(num1)
  };


  let note = undefined;
  let rawSignedTxn = 0;
  let confirmedTxn = 0;
  var amount = 0;
  let sender = 0;
  let recipient = 0;
  let revocationTarget = undefined;
  let closeRemainderTo = undefined;


  const algodClient = new algosdk.Algodv2(
    "",
    "https://node.testnet.algoexplorerapi.io",
    ""
  );
  useEffect(() => {
    console.log(props.zone);
  }, [props.zone])
  const forParams = async () => {
    let params = await algodClient.getTransactionParams().do();
    setParam(params);
  };

  // const getAlldata = async () => {
  //   if (
  //     WalletAddress != null &&
  //     WalletAddress != "" &&
  //     WalletAddress != undefined
  //   ) {
  //     axios
  //       .get(
  //         `https://node.algoexplorerapi.io/v2/accounts/BPWFGEA5SJGMTL4FXO4HDHCOQVMCDZCP7ASGUKQHZEP775NAGRDGLDR2M4`
  //       )
  //       .then(async (res) => {
  //         console.log(res.data);
  //         const allassets = [...res.data.assets];
  //         const createdasset = [...res.data['created-assets']]
  //         allassets.map(async (item, index) => {
  //           if (item.amount == 1) {
  //             var temp = Nfts
  //             const foundInCreated = await createdasset.find((element) => {
  //               return element.index === item['asset-id'];
  //             })
  //             let tempManager = foundInCreated.params.manager.slice(0, 10) + "...." + foundInCreated.params.manager.slice(48, 58)
  //             setNfts(prev => [...prev, { index: foundInCreated.index, params: foundInCreated.params, manager: tempManager }])
  //           } else {
  //             let temp = StakedNfts
  //             const foundInCreated = await createdasset.find((element) => {
  //               return element.index === item['asset-id'];
  //             })
  //             if (foundInCreated == null || foundInCreated == undefined || foundInCreated == "") { } else {
  //               temp.push({ index: foundInCreated.index, params: foundInCreated.params })
  //               setStakedNfts(temp)
  //             }
  //           }
  //         })
  //         console.log(allassets);
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //         setLoadingState(false)
  //         toast(err.toString())
  //       });
  //   }
  // };
  const getAlldata = async () => {
    if (
      WalletAddress != null &&
      WalletAddress != "" &&
      WalletAddress != undefined
    ) {
      axios
        .get(
          `https://node.testnet.algoexplorerapi.io/v2/accounts/${WalletAddress}`
        )
        .then(async (res) => {
          const allassets = [...res.data.assets];
          allassets.map((item, index) => {
            if (item.amount == 1) {
              axios.get(`https://node.testnet.algoexplorerapi.io/v2/assets/${item['asset-id']}`).then(res => {
                if (res.data.params.creator == "VRWVGZLXZRFIE5FEPM36G26VKCPGFCX25BRVCNWAEVUBB752VCAB6Q3OQM") {
                  console.log(item['asset-id']);
                  console.log(res.data.params);
                  setNfts(prev => [...prev, { index: item['asset-id'], params: res.data.params }])
                }
              }
              )
            }
          })

          console.log(allassets);
        })
        .catch((err) => {
          console.log(err);
          setLoadingState(false)
          toast(err.toString())
        });




    }
  };

  const getAllStaked = async () => {
    const q = query(collection(db, "stakeInfo"), where("WalletAddress", "==", localStorage.WalletAddress), where("isStaked", "==", true));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      console.log(doc.data());
      axios.get(`https://node.testnet.algoexplorerapi.io/v2/assets/${doc.data().assetid}`).then(res => {
        // console.log(res);
        // let temp = StakedNfts;
        // temp.push({
        //   index: res.data.index, params: res.data.params
        // })
        setStakedNfts(prev => [...prev, { index: res.data.index, params: res.data.params }])
      })

    });


  }

  useEffect(() => {
    getAllStaked()
  }, [])

  const WalletListner = () => {
    if (localStorage.WalletAddress) {
      setWalletAddress(localStorage.WalletAddress);
    }
  };
  useEffect(() => {
    setLoadingState(false)
  }, [Nfts])
  useEffect(() => {
    console.log(StakedNfts);
  }, [StakedNfts])

  const StakeToken = async function (myassetID) {
    window.scrollTo(0, 0)
    setLoadingState(true)
    const tempasset = Number(myassetID)
    try {
      console.log("----------------------------------optin In Asset To Global Account STARTS----------------------------------");
      console.log(tempasset);
      console.log(FungTokenAccount.addr);
      sender = FungTokenAccount.addr
      recipient = sender
      amount = 0;
      let opttxnnn = algosdk.makeAssetTransferTxnWithSuggestedParams(
        sender,
        recipient,
        closeRemainderTo,
        revocationTarget,
        amount,
        note,
        tempasset,
        params);
      rawSignedTxn = opttxnnn.signTxn(FungTokenAccount.sk);
      let opttx = await algodClient.sendRawTransaction(rawSignedTxn).do();
      toast(opttx.txId.toString())
      // confirmedTxn = await algosdk.waitForConfirmation(algodClient, opttx.txId, 4);
      // console.log("Transaction " + opttx.txId + " confirmed in round " + confirmedTxn["confirmed-round"]);
      console.log("----------------------------------optin In Asset To Global Account ENDS----------------------------------");
      console.log("---------------------------------------------Transfering Asset Function STARTS----------------------------------------");
      sender = WalletAddress;
      recipient = FungTokenAccount.addr;
      amount = 1;
      note = undefined;
      let transfertogloble = algosdk.makeAssetTransferTxnWithSuggestedParams(
        sender,
        recipient,
        closeRemainderTo,
        revocationTarget,
        amount,
        note,
        tempasset,
        params);

      amount = 0
      sender = WalletAddress
      recipient = WalletAddress

      let rewardAsset = 145406600;
      let optintogloble = algosdk.makeAssetTransferTxnWithSuggestedParams(
        sender,
        recipient,
        closeRemainderTo,
        revocationTarget,
        amount,
        note,
        rewardAsset,
        params);



      let transfertoglobletx = await myAlgoWallet.signTransaction([transfertogloble.toByte(), optintogloble.toByte()]);
      const optins = await algodClient.sendRawTransaction(transfertoglobletx[0].blob).do()
      const freezetxs = await algodClient.sendRawTransaction(transfertoglobletx[1].blob).do().then(res => {
        console.log("Transacrtion id", res.txId);
        savetoFirebase(res.txId, tempasset)
      }).catch(err => {
        setLoadingState(false)
        toast(err.toString())
      });
      console.log("---------------------------------------------Transfering Asset Function ENSDS----------------------------------------");

    } catch (er) {
      console.log(er);
      setLoadingState(false)
      toast(er.toString())
    }
  }

  const savetoFirebase = async (transactionid, assetid) => {
    const stakeInfoRef = collection(db, "stakeInfo");
    console.log(assetid);

    console.log(WalletAddress);
    console.log(props.zone);
    await setDoc(doc(db, "stakeInfo", assetid.toString()), {
      WalletAddress: WalletAddress,
      zone: props.zone,
      zoneReward: props.reward,
      date: Date.now(),
      transactionid: transactionid,
      assetid: assetid,
      isUnstaked: false,
      isStaked: true,
    }).then(res => {
      setLoadingState(false)
      toast("Staked Successfully")
      setTimeout(() => {
        window.location.reload();
      }, 4000);
    }).catch(err => {
      setLoadingState(false)
      toast(err.toString())
    })

  }

  const myCustomToast = (amount, trxId) => {
    return (
      <>
        <h5 className="custom-toast-h5">You have Earned  {amount / 100} FT Tokens </h5>
        <a className="custom-toast-a" href={`https://testnet.algoexplorer.io/tx/${trxId}`} target="_blank">Check Your Transaction On <img className="img-fluid" src="../../assets/images/algorand.png" /></a>
      </>
    )
  }

  const UnstakeNFT = async (assetID) => {
    setLoadingState(true)
    window.scrollTo(0, 0)
    const bodyelem = document.getElementsByTagName("BODY")[0];
    bodyelem.style.height = "100%"
    bodyelem.style.margin = "0"
    bodyelem.style.overflow = "hidden"
    const tempAssetID = Number(assetID);
    let sender = FungTokenAccount.addr;
    let recipient = WalletAddress;
    let amount = 1
    let note11 = undefined;
    let closeRemainderTo = undefined
    let revocationTarget = undefined
    console.log("---------------------------Transfer NFT From Globle Account To User Account-------------");
    let rtxn = algosdk.makeAssetTransferTxnWithSuggestedParams(
      sender,
      recipient,
      closeRemainderTo,
      revocationTarget,
      amount,
      note11,
      tempAssetID,
      params
    );
    let rawSignedTxn2 = rtxn.signTxn(FungTokenAccount.sk);
    let opttx = await algodClient.sendRawTransaction(rawSignedTxn2).do().then(async (res) => {
      const cityRef = doc(db, "stakeInfo", tempAssetID.toString())
      await setDoc(cityRef, {
        isUnstaked: true,
        isStaked: false,
        date: Date.now()
      }, { merge: true })

      toast("NFT is Unstaked")
      setTimeout(() => {
        window.location.reload()
      }, 3000);
    })
    if (Number(dateobj[tempAssetID]) > 0) {
      console.log("-----------------------------Tranfering FT from Global account to user---------------------------");
      sender = FungTokenAccount.addr;//global account
      recipient = WalletAddress; //user account
      let temp = 145406600
      amount = Number(dateobj[tempAssetID]) * 100;


      let note = undefined
      let rtxnn = algosdk.makeAssetTransferTxnWithSuggestedParams(
        sender,
        recipient,
        closeRemainderTo,
        revocationTarget,
        amount,
        note,
        temp,
        params);
      let rawSignedTxn22 = rtxnn.signTxn(FungTokenAccount.sk)

      await algodClient.sendRawTransaction(rawSignedTxn22).do().then(async (res) => {
        console.log(res.txId);
        const cityRef = doc(db, "stakeInfo", tempAssetID.toString())
        await setDoc(cityRef, {
          isUnstaked: true,
          isStaked: false,
          date: Date.now()
        }, { merge: true })
      })

    }
  }

  const ClaimReward = async (tempAssetID) => {
    const bodyelem = document.getElementsByTagName("BODY")[0];
    let temp = 145406600
    console.log("-----------------------------Tranfering FT from Global account to user---------------------------");
    let sender = FungTokenAccount.addr;//global account
    let recipient = WalletAddress; //user account
    // firebaseStake
    let amount = dateobj[tempAssetID] * 100;
    let revocationTarget = undefined;
    let closeRemainderTo = undefined;
    let rtxnn = algosdk.makeAssetTransferTxnWithSuggestedParams(
      sender,
      recipient,
      closeRemainderTo,
      revocationTarget,
      amount,
      note,
      temp,
      params);
    let rawSignedTxn2 = rtxnn.signTxn(FungTokenAccount.sk)
    await algodClient.sendRawTransaction(rawSignedTxn2).do().then(res => {
      console.log(res.txId);
      setLoadingState(false)
      bodyelem.style.overflow = "auto"
      toast(myCustomToast(amount, res.txId), {
        onClose: () => {
          window.location.reload()
        },
        autoClose: false
      }).catch(er => {
        setLoadingState(false)
        toast(er.toString())
      });
    })

  }

  const getFirebase = async () => {
    const querySnapshot = await getDocs(collection(db, "stakeInfo"));
    querySnapshot.forEach((doc) => {
      let temp = firebaseStake;
      temp.push({

        documentid: doc.id,
        date: doc.data().date,
        assetid: doc.data().assetid,
        stakeClicked: doc.data().stakeClicked,
        transactionid: doc.data().transactionid,
        zone: doc.data().zone,
        zoneReward: doc.data().zoneReward,
      })
      setfirebaseStake(temp)
    });
    calculateRewardInterval()
    setInterval(() => {
      calculateRewardInterval()
    }, [60000])
  }

  const calculateRewardInterval = () => {
    var temp1 = 0
    firebaseStake.map((item, index) => {
      temp1 = Date.now() - item.date
      let timeinday = Math.floor((((temp1 / 1000) / 60) / 60) / 24)
      let rewardinday = item.zoneReward / 7;
      let rewardall = timeinday * rewardinday
      setdateobj(existingValues => ({
        ...existingValues,
        [item.assetid]: rewardall,
      }))
    })
  }

  const createGlobleAccount = () => {
    const account = algosdk.mnemonicToSecretKey("puzzle bind bracket festival adapt middle chief project same crumble shaft route lion hidden whip inmate sample neglect repeat ostrich inquiry march motor absorb unveil")
    setFta(account)
  }

  const createNFTGlobleAccount = () => {
    const NFtGlobalAccount = algosdk.mnemonicToSecretKey("original float agree velvet surround empower volume diesel raise acid canvas expect sound age law turtle fiscal essence smile naive lemon clerk orient above pretty")
    setNFtGA(NFtGlobalAccount)
  }
  const getFirebasedata = async () => {
    const q = query(collection(db, "RewardInfo"));
    const querySnapshot = await getDocs(q);
    var temp = {}
    querySnapshot.forEach((doc) => {
      temp[doc.id] = Object.values(doc.data())[0]
    });
    setfirebaseData(temp)
  }


  useEffect(() => {
    getFirebasedata()

  }, [])
  useEffect(() => {

    console.log(firebaseData);
  }, [firebaseData])
  useEffect(() => {
    createGlobleAccount()
    createNFTGlobleAccount()
  }, [])
  useEffect(() => {
    getFirebase()
  }, [])
  useEffect(() => {
    WalletListner();
  }, []);
  useEffect(() => {
    forParams();
  }, []);
  useEffect(() => {
    getAlldata();
  }, [WalletAddress]);

  return (
    <div className="mynfts">
      <TopBar />
      {/* loading frontend */}
      {loadingState ? (
        <div className="loader-wrao" style={{ visibility: "visible" }}>
          <div className="loader"></div>
        </div>) : <></>
      }
      <section className="north-staking mycustomcontainer">
        <div className="section-heading">
          <h1>{props.zone} SEGMENT NFTS </h1>
        </div>

        <div className="content-heading">
          <h2>NFTs For Staking</h2>
        </div>
        <div className="north-contnet">
          <div className="row">
            {
              Nfts && Nfts.length > 0 ?
                (Nfts.map((item, index) => {
                  const assetid = item.assedID;
                  return (<div className="col-xl-3 col-lg-4 col-md-6 col-12 d-center" key={index}>
                    <div className="my-nfts mt-3 ">
                      <div className="nft-card">
                        <div className="nft-card-header">
                          <img

                            src={item.params.url}
                            alt=""
                            className="img-fluid"
                          />
                          <div className="favourite">
                            <Checkbox
                              {...label}
                              icon={<FavoriteBorder />}
                              checkedIcon={<Favorite />}
                            />
                          </div>
                        </div>
                        <div className="nft-card-body">
                          <div className="nft-title">
                            <h5>{item.params.name}</h5>
                          </div>
                          <div className="nft-card-detail">
                            <div className="ranking ">
                              <h4>Unit Name</h4>
                              <h6>{item.params["unit-name"]}</h6>
                            </div>
                            <div className="pricing">
                              <div className="price">


                                <h4>Pasty Van Co</h4>
                              </div>

                            </div>
                          </div>
                          <div className="nft-buy">
                            <button id={item.index} onClick={(e) => handleShow(e, item.params, item.manager)}>Stake</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>)
                })) :
                <> </>}
          </div>
        </div>

        <div className="content-heading">
          <h2>Staked NFTs</h2>
        </div>
        <div className="north-contnet">
          <div className="row">
            {
              StakedNfts && StakedNfts.length > 0 ?
                (StakedNfts.map((item, index) => {
                  // const assetid = item.assedID;
                  return (<div className="col-xl-3 col-lg-4 col-md-6 col-12 d-center" key={index}>
                    <div className="my-nfts mt-3 ">
                      <div className="nft-card">
                        <div className="nft-card-header">
                          <img
                            src={item.params.url}
                            alt=""
                            className="img-fluid"
                          />
                          <div className="favourite">
                            <Checkbox
                              {...label}
                              icon={<FavoriteBorder />}
                              checkedIcon={<Favorite />}
                            />
                          </div>
                        </div>
                        <div className="nft-card-body">
                          <div className="nft-title">
                            <h5>{item.params.name}</h5>
                          </div>
                          <div className="nft-card-detail">
                            <div className="pricing">
                              <div className="price">

                                <div className="reward-para" id={item.index + 1}>
                                  Reward: <span>
                                    {dateobj[item.index]}
                                  </span>
                                  <h6 className="txt-span">FT tokens</h6>

                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="nft-buy">
                            <button id={item.index} onClick={(e) => UnstakeNFT(e.target.id)}>Unstake and Claim</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>)
                })) : <> </>}
          </div>
        </div>
        {/* Modal */}
        <Modal
          show={show}
          onHide={handleClose}
          centered
          className="stake-modal"
          size="xl"
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton closeVariant="white"></Modal.Header>
          <Modal.Body >
            <div className="left">
              <img
                src={popupimage}
                alt=""
                className="img-fluid"
              />
            </div>
            <div className="right w-100">
              <h1>{AllParams.name} </h1>
              <h2>
                <span>Manager</span> {AllParamsManager}
              </h2>
              <h2>
                <span>ASSET ID</span> {myassetID}
              </h2>
              <h2>
                <span>Unit Name</span> {AllParams['unit-name']}
              </h2>
              <div className="btn-stake">
                <button onClick={() => StakeToken(myassetID)}>Stake</button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </section >

      <Footer />
    </div >
  );
};
export default MintPage;
